import React from 'react';
import LegalDocument from './LegalDocument';
import termsContent from './content/terms-of-service.md?raw';

interface TermsOfServiceProps {
  embedded?: boolean;
}

const TermsOfService: React.FC<TermsOfServiceProps> = ({ embedded = false }) => {
  return <LegalDocument content={termsContent} embedded={embedded} />;
};

export default TermsOfService;
